import React, { useState } from "react";
import { useSelector } from "react-redux";

// Components
import MovementAnimalReportParameter from "../movementAnimalReportParameter";
import Breed from "../breed";
import DeathReasons from "../deathReasons";
import AnimalHandlingAlert from "../animalHandlingAlert";
import Measurement from "../measurement";

// Styles
import { Tabs } from "antd";
import useModuleContext from "../../hooks/useModuleContext";
import { Container } from "./styles";

const AnimalParameters = () => {
  const { translation } = useSelector((state) => state.app);

  const [tabSelect, setTablSelect] = useState("3");
  const { isAllowedFunctions } = useModuleContext();

  return (
    <Container>
      <Tabs
        type="card"
        defaultActiveKey="3"
        activeKey={tabSelect}
        onChange={(key) => setTablSelect(key)}
      >
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.ageRange}</span>}
          key="3"
          disabled={!isAllowedFunctions(["ANIMALS"])}
        >
          <MovementAnimalReportParameter />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.breed}</span>}
          key="1"
          disabled={!isAllowedFunctions(["ANIMALS"])}
        >
          <Breed />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.deathReasons}</span>}
          key="2"
          disabled={!isAllowedFunctions(["ANIMALS"])}
        >
          <DeathReasons />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.handlingAlerts}</span>}
          key="4"
          disabled={!isAllowedFunctions(["ANIMALS"])}
        >
          <AnimalHandlingAlert />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={<span>{translation.parameters.tabs.measurement}</span>}
          key="5"
          disabled={!isAllowedFunctions(["ANIMALS"])}
        >
          <Measurement />
        </Tabs.TabPane>
      </Tabs>
    </Container>
  );
};

export default AnimalParameters;
